import BaseService from '@/services/base-service';
import { RequestConfig } from '@/interfaces/request-config.interface';
import HttpService from './http.service';
import { ReprocessRequestModel } from '@/models/reprocess-request.model';
import { ReprocessResponseModel } from '@/models/reprocess-response.model';
import { ReprocessLogModel } from '@/models/reprocess-log.model';
import { CleanLogModel } from '@/models/clean-log.model';

export default class WhatsappService extends BaseService {
  constructor(httpService: HttpService) {
    super(httpService);
  }

  async reconfigureWebhook(apiKey: string, licenseCode: string): Promise<void> {
    const config: RequestConfig = {
      headers: {
        api_key: apiKey,
        license_code: licenseCode,
      },
    };

    await this.httpService
      .withoutToken()
      .post(Number, `${this.apiUrl}/whatsapp/configs/reconfigure-webhook`, {}, config);
  }

  async reprocessByDate(startDate: string, endDate: string): Promise<ReprocessResponseModel> {
    const request: ReprocessRequestModel = {
      startDate,
      endDate,
    };

    return (await this.httpService.post(
      ReprocessResponseModel,
      `${this.apiUrl}/whatsapp/webhook/reprocess-by-date`,
      request
    )) as ReprocessResponseModel;
  }

  async getReprocessLogs(): Promise<ReprocessLogModel[]> {
    return (await this.httpService.get(
      ReprocessLogModel,
      `${this.apiUrl}/whatsapp/webhook/reprocess-logs`
    )) as ReprocessLogModel[];
  }

  async cleanLogs(days: number): Promise<number> {
    return (await this.httpService.delete(
      `${this.apiUrl}/whatsapp/webhook/log/clean/${days}`
    ) as unknown) as number;
  }

  async getCleanLogs(): Promise<CleanLogModel[]> {
    return (await this.httpService.get(
      CleanLogModel,
      `${this.apiUrl}/whatsapp/webhook/log/clean-logs`
    )) as CleanLogModel[];
  }
}
